import $ from 'jquery';
import * as headerCart from 'header.cart';
import * as headerLogo from 'header.logo';
import * as headerMyAccountDrawer from 'header.myaccountdrawer';
import * as headerSimpleFlyout from 'header.simpleflyout';
import * as headerMyaccount from 'header.myaccount';
import * as headerStorefinderCore from 'header.storefinder.core';
import * as headerStoreFinderInline from 'header.storefinder.inline';
import * as headerTooltips from 'header.tooltips';
import * as headerSearchLite from 'header.search.lite';
import * as footerPclink from 'footer.pcLink';
import * as gestureHandler from 'global.gestureHandler';
import * as headerAnalytics from 'header.analytics';
import * as headerSticky from 'header.sticky';
import deliveryZip from 'header.deliveryzip';
import * as headerCartReminder from 'header.cartReminders';

// Initialize all modules
const initializeModules = () => {
  headerAnalytics.init();
  headerCart.init();
  headerSimpleFlyout.init();
  headerLogo.init();
  headerMyAccountDrawer.init();
  headerSearchLite.init();
  headerMyaccount.init();
  headerTooltips.init();
  headerStorefinderCore.init();
  headerStoreFinderInline.init();
  footerPclink.init();
  gestureHandler.init();
  headerSticky.init();
  deliveryZip.init();
  headerCartReminder.init();

  // Triggers HFApp is loaded and ready
  document.dispatchEvent(new Event('hfapp-ready', {
    bubbles: true,
    cancelable: false,
    detail: null
  }));
  $('body').trigger('hfapp-ready');
};

window.addEventListener('DOMContentLoaded', (event) => initializeModules());
